import axios from 'axios';
import {rootUrl} from './rootUrl.js';

export let member = {
  createMemberAddress(params) {
    return axios.post(rootUrl + '/member/createMemberAddress', params)
  },
  getMemberAddress(params) {
    return axios.post(rootUrl + '/member/getMemberAddress', params)
  },
// 账号信息---展示用户信息和企业信息
  getUserInfoForWechat(params) {
    return axios.post(rootUrl + '/member/getUserInfoForWechat', params)
  },
// 账号信息---展示用户信息和企业信息
getUserInfo(params) {
 return axios.post(rootUrl + '/member/getUserInfo', params)
},
  //获取优惠券
  getMemberThanksgivingTicketList(params) {
    return axios.post(rootUrl + '/member/getMemberThanksgivingTicketList', params)
  },
  sendmail(params) {
    return axios.post(rootUrl + '/member/sendmail', params)
  },
  //是否有优惠券快过期
  isIncludeExpiredCoupons(params) {
    return axios.post(rootUrl + '/member/isIncludeExpiredCoupons', params)
  },
  getOrder(params) { //订单详情页
    return axios.post(rootUrl + '/tbOrder/getOrder', params)
},
 //聚合支付
 unifiedOrder(params) {
  return axios.post(rootUrl + '/payOrder/unifiedOrder', params)
},
 //  订单线下付款
 offLinePay(params) {
  return axios.post(rootUrl + '/tbOrder/offLinePay', params)
},
 //  保存openId
 saveUserOpenId(params) {
  return axios.post(rootUrl + '/member/saveUserOpenId', params)
},
  //可使用服务次数
  getUsableNum(params) {
    return axios.post(rootUrl + '/timestamp/getUsableNum', params)
},
//获取用户的时间戳服务账户
getTsAccount(params) {
    return axios.post(rootUrl + '/timestamp/getTsAccount', params)
},
//创建时间戳订单
insertTsAppInfo(params) {
    return axios.post(rootUrl + '/timestamp/insertTsAppInfo', params)
},
//已保护文件
getTimeStampOrder(params) {
    return axios.post(rootUrl + '/timestamp/getTimeStampOrder', params)
},
//时间戳订单
getTsAppInfo(params) {
    return axios.post(rootUrl + '/timestamp/getTsAppInfo', params)
},
//时间戳创建订单
createOrderTimestamp(params) {
    return axios.post(rootUrl + '/timestamp/createOrder', params)
},
//时间戳上传文件
createHashcodeAndFileId(params) {
    const formData = new FormData()
    for (let i in params) {
        formData.append(i, params[i])
    }
    return axios.post(rootUrl + '/timestamp/createHashcodeAndFileId', formData) // 文礼复制峰哥的接口;
},
//时间戳专用国家
getTsCountryList(params) {
  return axios.post(rootUrl + '/country/getTsCountryList', params)
},
  /*异议人信息填写 获取默认申请人接口*/
  getDefaultApplicant(params) {
    return axios.post(rootUrl + '/applicantInfo/getDefaultApplicant', params)
  },
   //  申请人信息
   appliInfo(params) {
    return axios.post(rootUrl + '/applicantInfo/getApplicantList', params)
},
 //申请人国籍
 tmCountryList(params) {
  return axios.post(rootUrl + '/country/getNationalityList', params)
},
//  申请人修改查询
modyfiDelAppli(params) {
  return axios.post(rootUrl + '/applicantInfo/getApplicant', params)
},
 //  修改申请人信息
 modyfiappli(params) {
  return axios.post(rootUrl + '/applicantInfo/insertApplicant', params)
},
 //  申请人删除
 delAppli(params) {
  return axios.post(rootUrl + '/applicantInfo/deleteApplicant', params)
},
 //  使用优惠券支付算付款
 useCouponsPay(params) {
  return axios.post(rootUrl + '/tbOrder/useCouponsPay', params)
},
};



// WEBPACK FOOTER //
// ./src/service/member.js